var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0093 12.2164L20.0154 12.0187L13.6775 11.823L12.9229 13.5832L10.6087 6.49756L8.51367 12.0184H3.8523C3.26019 11.1277 2.9608 10.0802 3.00412 9.01339C3.05751 7.69867 3.62749 6.45185 4.59983 5.52277C5.57218 4.59369 6.87506 4.05098 8.24739 4.00341C9.61972 3.95584 10.9601 4.40692 12 5.26624C13.0399 4.40692 14.3803 3.95584 15.7526 4.00341C17.1249 4.05098 18.4278 4.59369 19.4002 5.52277C20.3725 6.45185 20.9425 7.69867 20.9959 9.01339C21.0425 10.1603 20.6929 11.285 20.0093 12.2164ZM19.3088 12.9973L14.328 12.8435L12.7963 16.4166L10.5381 9.50225L9.20377 13.0184H4.71322L12 20L19.3088 12.9973Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.16795f3c166efcc7c67009f0f40aaeb0.svg";
export { ForwardRef as ReactComponent };